export default __webpack_public_path__ + "static/media/Japan_Particle_0004_Yamato_Blast1.9b906e77.png";